import script from "./DynamicTemplate.vue?vue&type=script&lang=js"
export * from "./DynamicTemplate.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__